import { MediaText, Spread } from 'editor/src/store/design/types';

const getTextElementsUsedInSpread = (spread: Spread) =>
  (spread.pages[0].groups.media?.filter((el) => el.type === 'text' && !el.sample) as MediaText[]) || [];

export default getTextElementsUsedInSpread;
